import CompanyCreationLayout from "../../CompanyCreation/Steps/CompanyCreationPage/CompanyCreationPageLayout";
import React, { FC } from "react";
import { flowType } from "../currentFlowType";

interface TraderProps {}

export const Trader: FC<TraderProps> = () => <CompanyCreationLayout flowType={flowType.TRADER} />;

export default Trader;
